import { configureStore, type Middleware } from "@reduxjs/toolkit";
import logger from "redux-logger";

import appSlice from "@/redux/app/appSlice";
import authSlice from "@/redux/auth/authSlice";
import counterSlice from "@/redux/counter/counterSlice";

// Global middleware
const middleware: Middleware[] = [];
// Development middleware
// if (import.meta.env.DEV) {
//   middleware.push(logger);
// }

// Create the global store
const store = configureStore({
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware),
  reducer: {
    app: appSlice,
    auth: authSlice,
    counter: counterSlice,
  },
});

// Inferred types
export type AppDispatch = typeof store.dispatch;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

export default store;
